"use client";

import { SearchODS } from "./SearchODS";
export const ODSSelector = ({ data, handleOnChange, selectedValue }) => {
  return (
    <>
      <div className="flex justify-end">
        <SearchODS data={data} handleOnChange={handleOnChange} />
      </div>
      <div className=" gap-5 mb-5">
        <label>
          <span className="text-2xl text-blue-800 font-bold">
            Objetivo de desarrollo sostenible
          </span>
          <select
            value={selectedValue?.index ?? ""}
            onChange={(e) => handleOnChange(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value="">Todos</option>
            {data.map(({ label, index }) => (
              <option key={index} value={index}>
                {`ODS ${index}: ${label}`}
              </option>
            ))}
          </select>
        </label>
      </div>
    </>
  );
};
